import Loading from "../ui/Loading";

export default function AuthLoading() {
  return <Loading fullScreen message="در حال بارگذاری..." size="lg" />;
}
